// apps/admin/src/pages/whitelist/tabs/WhitelistConfigTab.tsx
//
// The rules an admin CANNOT switch off, stated where an admin will look.
//
// Each of these is enforced server-side in
// `payments/services/card-payment-permission.service.ts` and would otherwise
// only surface as a refusal the operator has to reverse-engineer: "I enabled
// this merchant, why is card payment still refused?" (answer: they are
// invoice-billed), or "why did the refund go to the wallet?" (answer: there
// is no card refund path yet).
//
// Deliberately not a settings form. Turning any of these into a toggle would
// mean offering an operator a switch that breaks correctness — double-billing
// an invoice-billed merchant, in the first case.

import type { JSX } from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from '../../../i18n/useTranslation.js';

export function WhitelistConfigTab(): JSX.Element {
  const { t } = useTranslation('finance');

  const rules = [
    { key: 'invoiceRule', testId: 'whitelist-rule-invoice' },
    { key: 'refundRule', testId: 'whitelist-rule-refund' },
    { key: 'threeDsRule', testId: 'whitelist-rule-3ds' },
  ] as const;

  return (
    <div className="space-y-4" data-testid="whitelist-config-tab">
      <h2 className="text-sm font-semibold text-pw-text">
        {t('whitelist.config.heading')}
      </h2>

      <ul className="space-y-2">
        {rules.map((r) => (
          <li
            key={r.key}
            data-testid={r.testId}
            className="rounded border border-pw-border bg-pw-surface px-4 py-3 text-sm text-pw-text"
          >
            {t(`whitelist.config.${r.key}`)}
          </li>
        ))}
      </ul>

      <p className="text-xs text-pw-text-muted">
        {t('whitelist.config.limitsHint')}
      </p>

      <Link
        to="/billing/fraud-settings"
        className="inline-block text-sm text-pw-primary underline"
        data-testid="whitelist-config-fraud-link"
      >
        {t('whitelist.config.fraudLink')}
      </Link>
    </div>
  );
}

export default WhitelistConfigTab;
